import {
  createBrowserRouter,
  RouteObject,
  RouterProvider
} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import CustomerLogin from './pages/public/login.tsx'
import EnsureLogin from './ensure-login'
import { AppLayout } from './app-layout'
import Dashboard from './pages/private/dashboard/index.tsx'
import SetupPassword from './pages/public/setup-password.tsx'
import LoadingScreen from './loading-screen.tsx'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import ForgotPasswordPage from './pages/public/forgot-password.tsx'
import ResetPasswordPage from './pages/public/reset-password.tsx'
import PageRegister from './pages/public/page-register.tsx'
import RegisterSuccessful from './pages/public/register-successful.tsx'
import NotFound from '../../components/NotFound.tsx'

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoadingScreen />
  },
  {
    path: '/customer/login',
    element: <CustomerLogin />
  },
  {
    path: '/customer/register',
    element: <PageRegister />
  },
  {
    path: '/customer/register-successful',
    element: <RegisterSuccessful />
  },
  {
    path: '/customer/forgot-password',
    element: <ForgotPasswordPage />
  },
  {
    path: '/customer/reset-password',
    element: <ResetPasswordPage />
  },
  {
    path: '/customer/setup-password',
    element: <SetupPassword />
  },
  {
    path: '/customer',
    element: <AppLayout />,
    children: [
      {
        path: '',
        index: true,
        element: <Dashboard />
      },
      {
        path: 'my-profile',
        element: <Navigate to='/customer' replace />
      },
      {
        path: 'set-password',
        element: (
          <EnsureLogin>
            <Navigate to='/customer' replace />
          </EnsureLogin>
        )
      }
    ]
  },
  { path: '*', element: <NotFound /> }
]

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)

const router = sentryCreateBrowserRouter(routes)

export default function CustomerAppRouter() {
  const { i18n } = useTranslation()
  useEffect(() => {
    void i18n.changeLanguage(import.meta.env.VITE_APP_LOCALE as 'nl')
  }, [i18n])
  return <RouterProvider router={router} />
}
